module.exports = __webpack_public_path__ + "img/gtsfly-logo-light.5bf125e0.svg";